import { createFileRoute } from '@tanstack/react-router'

import { installmentPlansQueryOptions } from '@/features/installments/api'
import { InstallmentPlansPage } from '@/features/installments/installment-plans-page'
import {
  type ParcelamentosSearch,
  parcelamentosSearchSchema,
  toInstallmentPlanListParams,
} from '@/features/installments/search'

export const Route = createFileRoute('/_authed/recebimentos/parcelamentos')({
  validateSearch: parcelamentosSearchSchema,
  loaderDeps: ({ search }) => ({ params: toInstallmentPlanListParams(search, 'receivable') }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(installmentPlansQueryOptions(deps.params)),
  component: Page,
})

function Page() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <InstallmentPlansPage
      kind="receivable"
      search={search}
      onSearchChange={(patch) => {
        // replace: filtrar não é navegação — empilhar cada tecla da busca faria
        // o "voltar" do navegador desfazer letra por letra.
        // `to` EXPLÍCITO + `prev` ANOTADO: sem os dois o destino fica ambíguo, o
        // updater cai em `any` (TS7006) e a navegação pode virar no-op silencioso.
        void navigate({
          to: '/recebimentos/parcelamentos',
          search: (prev: ParcelamentosSearch) => ({ ...prev, ...patch }),
          replace: true,
        })
      }}
    />
  )
}
